<template>
  <v-layout
    v-if="order"
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <h2
            v-if="!order.is_refunded"
            :style="successStyle"
          >{{ $t('payment_success') }}</h2>
          <h2
            v-else
            :style="failStyle"
          >{{ $t('payment_refunded') }}</h2>
          <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
          <div v-if="title">
            <h3 :style="titleStyle">
              {{ title }}
            </h3>
            <h4 :style="summaryStyle">{{ summary }}</h4>
            <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
          </div>
          <v-layout
            v-if="receiptNo"
            row
          >
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('receipt_no') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ receiptNo }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('store') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ order.location }}</v-flex>
          </v-layout>
          <v-layout v-if="receiverName && receiverName !== ''" row>
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('receiver') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ receiverName }}</v-flex>
          </v-layout>
          <v-layout v-if="receiverContact && receiverContact !== ''" row>
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('mobile') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ receiverContact }}</v-flex>
          </v-layout>
          <v-layout v-if="remarks && remarks !== ''" row>
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('remarks') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ remarks }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('open_date') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ printDate(order.created_at) }}</v-flex>
          </v-layout>
          <v-layout
            v-if="order.tablename"
            row
          >
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('table') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ order.tablename }}</v-flex>
          </v-layout>
          <v-layout
            v-if="order.pickup_time"
            row
          >
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ timeTitle }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ printDate(order.pickup_time) }}</v-flex>
          </v-layout>
          <v-layout
            v-if="order.address"
            row
          >
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('address') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ order.address }}</v-flex>
          </v-layout>
          <v-divider class="mt-2 mb-2" :color="theme.orders_divider_color" />
          <div v-for="(cat, category_name) in items" :key="category_name">
            <span
              class="name"
              :style="nameStyle"
            >{{ category_name }}</span>
            <div class="mt-2 mb-2">
              <div
                v-for="item in cat"
                :key="item.item_id"
              >
                <order-item
                  :item="item"
                  :order="id"
                />
              </div>
            </div>
          </div>
          <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
          <div>
            <v-layout row>
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                Subtotal
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                :style="nameStyle"
              >
                {{ $n(subTotal, 'currency') }}
              </v-flex>
            </v-layout>
          </div>
          <v-layout
            v-if="deliveryTotal > 0"
            row
          >
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              text-xs-right
              :style="nameStyle"
            >
              Delivery
            </v-flex>
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              text-xs-right
              :style="nameStyle"
            >
              {{ $n(deliveryTotal, 'currency') }}
            </v-flex>
          </v-layout>
          <v-layout
            v-if="svcTotal > 0"
            row
          >
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              text-xs-right
              :style="nameStyle"
            >
              SVC
            </v-flex>
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              text-xs-right
              :style="nameStyle"
            >
              {{ $n(svcTotal, 'currency') }}
            </v-flex>
          </v-layout>
          <v-layout
            v-if="gstTotal > 0"
            row
          >
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              text-xs-right
              :style="nameStyle"
            >
              GST
            </v-flex>
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              text-xs-right
              :style="nameStyle"
            >
              {{ $n(gstTotal, 'currency') }}
            </v-flex>
          </v-layout>
          <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
          <div>
            <v-layout
              v-if="parseFloat(discount) !== 0"
              row
            >
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                Discount
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                :style="nameStyle"
              >
                {{ $n(discount, 'currency') }}
              </v-flex>
            </v-layout>
            <v-layout
              v-if="isMember && parseFloat(used) !== 0"
              row
            >
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                Payment By Points
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                :style="nameStyle"
              >
                -{{ $n(used, 'currency') }}
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                <h4>Payable amount</h4>
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                :style="nameStyle"
              >
                <h4>{{ $n(order.payments_topay, 'currency') }}</h4>
              </v-flex>
            </v-layout>
            <div
              v-if="isMember && !order.is_refunded"
              :style="subtotalStyle"
            >
              <v-btn
                :color="theme.btn_color_secondary"
                flat
                :disabled="disableSendEmailBtn"
                @click="sendEmail"
              >{{ $t('email_receipt') }}</v-btn>
            </div>
          </div>
          <menu-item-dialog v-if="menuItemDialog && !(iOS && inIframe)" />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import OrderItem from '~/components/OrderItem2'
import MenuItemDialog from '~/components/MenuItemDialog'
import axios from 'axios'

export default {
  name: 'orders-view',
  metaInfo () {
    return { title: 'Order detail' }
  },
  components: {
    'page-title': PageTitle,
    'order-item': OrderItem,
    'menu-item-dialog': MenuItemDialog
  },
  data: () => ({
    disableSendEmailBtn: false,
    receiverName: null,
    receiverContact: null,
    remarks: null,
  }),
  props: {
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'language', 'enableMemberPoints'
    ]),
    ...mapGetters('menu', [
      'menuItemDialog'
    ]),
    ...mapGetters('order', [
      'orders', 'redeemed', 'orderMsg'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    successStyle () {
      return {
        display: 'inline-block',
        lineHeight: '40px',
        color: this.theme.msg_success_color
      }
    },
    failStyle () {
      return {
        display: 'inline-block',
        lineHeight: '40px',
        color: this.theme.msg_error_color
      }
    },
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    titleStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    summaryStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    subtotalStyle () {
      return {
        textAlign: 'right',
        marginTop: '20px'
      }
    },
    order () {
      return this.orders.find(o => parseInt(o.id) === parseInt(this.id))
    },
    items () {
      // Orders passed from API will have items in string (Queue related API)
      if (this.order) {
        let items
        try {
          items = JSON.parse(this.order.items)
        } catch (e) {
          items = this.order.items
        }
        if (this.language !== 'en-SG') {
          return _.groupBy(items, (item) => {
            return item.category_alternate_name ? item.category_alternate_name : item.category_name
          })
        }
        return _.groupBy(items, 'category_name')
      }
      return []
    },
    title () {
      if (this.enableMemberPoints && !this.order.is_refunded && this.earned > 0) {
        if (this.earned === 1) {
          return this.$t('you_earned') + '1' + this.$t('point')
        }
        return this.$t('you_earned') + this.earned + this.$t('points')
      }
      return null
    },
    summary () {
      if (this.redeemed === 1) {
        return this.$t('you_have_redeemed') + this.redeemed + this.$t('point_so_far')
      }
      return this.$t('you_have_redeemed') + parseFloat(Math.round(this.redeemed * 100) / 100).toFixed(2) + this.$t('points_so_far')
    },
    discount () {
      if (this.order && this.order.payments_discount) {
        return parseFloat(this.order.payments_discount).toFixed(2)
      }
      return 0
    },
    earned () {
      if (this.order && this.order.payments_topay > 0) {
        if (this.order.earned !== null) {
          return parseFloat(Math.round(this.order.earned * 100) / 100).toFixed(2)
        }
      }
      return 0
    },
    used () {
      if (this.order && this.order.used) {
        return parseFloat(Math.round(this.order.used * 100) / 100).toFixed(2)
      }
      return parseFloat(Math.round(this.order.payments_points * 100) / 100).toFixed(2)
    },
    subTotal () {
      if (this.order && this.order.sub_total) {
        return this.order.sub_total.replace(/[^\d.-]/g, '')
      }
      return 0
    },
    gstTotal () {
      if (this.order && this.order.gst_total) {
        return this.order.gst_total.replace(/[^\d.-]/g, '')
      }
      return 0
    },
    svcTotal () {
      if (this.order && this.order.svc_total) {
        return this.order.svc_total.replace(/[^\d.-]/g, '')
      }
      return 0
    },
    deliveryTotal () {
      if (this.order && this.order.delivery_total) {
        return this.order.delivery_total.replace(/[^\d.-]/g, '')
      }
      return 0
    },
    receiptNo () {
      if (this.order && this.order.queue_no) {
        return '#' + this.order.queue_no
      }
      return null
    },
    timeTitle () {
      if (this.order) {
        return this.order.address ? this.$t('delivery') : this.$t('pickup')
      }
      return null
    }
  },
  methods: {
    printDate (d) {
      const d2 = moment(d)
      const today = moment()
      const yesterday = moment().subtract(1, 'day')
      if (d2.isSame(today, 'day')) return this.$t('today_at') + d2.format('h:mm A')
      if (d2.isSame(yesterday, 'day')) return this.$t('yesterday_at') + d2.format('h:mm A')
      return d2.format('D MMMM YYYY \\at h:mm A')
    },
    async sendEmail () {
      this.disableSendEmailBtn = true
      this.$bus.$emit('showFullLoading', true)
      await this.$store.dispatch('order/sendMail', this.order)
      this.$bus.$emit('showFullLoading', false)
      let text
      if (this.orderMsg) {
        text = this.$t(this.orderMsg)
        this.disableSendEmailBtn = false
      } else {
        text = this.$t('email_receipt_success_notice')
      }
      this.$store.dispatch('responseMessage', {
        type: 'error',
        text: text,
        title: this.$t('email_receipt_title'),
        modal: true
      })
    }
  },
  async created () {
    if (!this.order) {
      this.$router.push({ name: 'orders' })
    }
    await this.$store.dispatch('menu/fetchMenuCats')
    if (this.isMember && this.order.queue_no && this.order.earned === null && this.order.used === null) {
      await this.$store.dispatch('order/fetchOrderPoints', {
        reference_id: this.order.reference_id,
        transaction_id: this.order.queue_no
      })
    }
    axios.post('/api/getOrderAdditionalInfo',{
      reference_id: this.order.reference_id,
      reference_type: 'activeOrder',
    }).then(response =>{
      this.receiverName = response.data.receiver_name
      this.receiverContact = response.data.receiver_contact
      this.remarks = response.data.remarks
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/order.vue